<template>
		<!-- Footer -->
		<div class="footer text-muted">
			&copy; 2020. Powered by <a href="https://apicodes.com" target="_blank" title="APICodes">APICodes</a>. All Rights Reserved.
		</div>
		<!-- /footer -->
</template>

<script>
export default {
  name: 'Footer',
  data () {
    return {

    }
  }
}
</script>

<style lang="css" scoped>
</style>


// WEBPACK FOOTER //
// src/components/admin/master/Footer.vue